'use client';

import * as React from 'react';
import parse from 'html-react-parser';

export interface IRenderHTMLProps {
  html: string;
}

const RenderHTML: React.FunctionComponent<IRenderHTMLProps> = (props) => {
  return <React.Fragment>{parse(props.html)}</React.Fragment>;
};

RenderHTML.displayName = 'RenderHTML';

export default RenderHTML;
